import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CHAVE_ACEITE = 'lizzi_food_cookies_aceitos';

export function CookieBanner() {
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    setVisivel(localStorage.getItem(CHAVE_ACEITE) !== 'true');
  }, []);

  function aceitar() {
    localStorage.setItem(CHAVE_ACEITE, 'true');
    setVisivel(false);
  }

  if (!visivel) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'var(--cor-texto)',
        color: 'var(--cor-branco)',
        padding: '16px 24px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 1000,
      }}
    >
      <p style={{ margin: 0, fontSize: '13px', maxWidth: '640px' }}>
        Usamos cookies para melhorar sua experiência no Lizzi Food. Ao continuar navegando, você concorda com nossa{' '}
        <Link to="/politica-de-privacidade" style={{ color: 'var(--cor-secundaria)' }}>
          Política de Privacidade
        </Link>
        .
      </p>
      <button
        onClick={aceitar}
        style={{
          background: 'var(--cor-gradiente)',
          color: 'var(--cor-branco)',
          border: 'none',
          borderRadius: 'var(--raio-padrao)',
          padding: '10px 20px',
          fontWeight: 600,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        Aceitar
      </button>
    </div>
  );
}
